var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M11.0257 2.35903C11.1903 2.19443 11.3857 2.06386 11.6008 1.97478C11.8158 1.88569 12.0463 1.83984 12.2791 1.83984C12.5119 1.83984 12.7424 1.88569 12.9575 1.97478C13.1725 2.06386 13.3679 2.19443 13.5325 2.35903C13.6971 2.52363 13.8277 2.71904 13.9168 2.93411C14.0059 3.14917 14.0517 3.37967 14.0517 3.61245C14.0517 3.84524 14.0059 4.07574 13.9168 4.2908C13.8277 4.50587 13.6971 4.70128 13.5325 4.86588L5.07192 13.3265L1.625 14.2666L2.56507 10.8196L11.0257 2.35903Z",
          stroke: "#010A11",
          "stroke-width": "1.25342",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }